import { useEffect, useState } from 'react';
import { getDashboardOverview } from '../api/dashboard.api';
import { writeDashboardSnapshot } from '../dashboard.cache';
import { useInitialDashboardSnapshot } from '../DashboardHydrationBoundary';
import type { DashboardOverview } from '../types/dashboard.types';

export function useDashboard() {
  const initialDashboard = useInitialDashboardSnapshot();
  const [dashboard, setDashboard] = useState<DashboardOverview | null>(initialDashboard);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    getDashboardOverview()
      .then((freshDashboard) => {
        if (!isMounted) {
          return;
        }

        setDashboard(freshDashboard);
        writeDashboardSnapshot(freshDashboard);
      })
      .catch(() => {
        if (isMounted) {
          setError('خطا در دریافت اطلاعات داشبورد');
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { dashboard, loading, error };
}
